import React from 'react';
import { Supply } from '../models/timeline';
import styled from 'styled-components';
import { FONT_SIZE_SCALE, PrintColors } from './PrintElements';

const SuppliesContentContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
`;

const SupplyItem = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: 2px solid ${PrintColors.LightGreen};
  justify-content: space-between;
`;

const Checkbox = styled.div`
  width: 15px;
  height: 15px;
  border: 2px solid ${PrintColors.LightGray};
  border-radius: 2px;
`;

const SuppliesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  padding: 0 50px;
  break-inside: avoid;
`;

const SupplyQuantity = styled.p`
  white-space: nowrap;
  align-self: center;
`;

export default function Supplies({
  supplies,
  fontSize,
}: {
  supplies: Supply[];
  fontSize: keyof typeof FONT_SIZE_SCALE;
}) {
  return (
    <SuppliesContainer>
      <h5 style={{ fontSize: FONT_SIZE_SCALE[fontSize].h5 }}>Supplies</h5>
      <SuppliesContentContainer>
        {supplies?.map(supply => (
          <SupplyItem key={supply.name}>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 10 }}>
              <Checkbox />
              <p>{supply.name}</p>
            </div>
            <SupplyQuantity>{supply.quantity}</SupplyQuantity>
          </SupplyItem>
        ))}
      </SuppliesContentContainer>
    </SuppliesContainer>
  );
}
